module.exports = __webpack_public_path__ + "media/images/bg-circle-front-1edd6162.png";